import { at } from 'lodash';
import { useField } from 'formik';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import { useEffect } from 'react';
import RadioGroup from '@mui/material/RadioGroup';

export default function RadioField(props: any) {
  const { label, children, data, setErrorMsg, ...rest } = props;
  const [field, meta] = useField(props);
  const { value: toggleValue } = field;
  const [touched, error] = at(meta, 'touched', 'error');
  const isError: boolean = touched && error && true;

  function _renderHelperText() {
    if (isError) {
      if (setErrorMsg) {
        setErrorMsg(error);
      }
    } else {
      if (setErrorMsg) {
        setErrorMsg('');
      }
    }
  }

  useEffect(() => {
    _renderHelperText();
  });
  return (
    <FormControl {...rest} error={isError}>
      <RadioGroup row {...field} value={toggleValue ? toggleValue : ''}>
        {children}
      </RadioGroup>
      {!setErrorMsg && !!isError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
